import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Space } from 'tdesign-react';
import { connect } from 'react-redux';
import CodeMirrorLight from '@/components/CodeMirrorLight';
import { setCodeContent, setTemplate, toggleTemp } from '@/slices/execScriptSlice';
import OperateTitle from '../../components/OperateTitle';
import SelectScriptModal from './Modal';

function SelectScript({
  isTemp,
  toggleTemp,
  template,
  setTemplate,
  setCodeContent,
  cluster,
  codeContent,
}) {
  const [visible, setVisible] = useState(false);

  // 当前步骤
  const step = useMemo(() => {
    // k8s容器 clusterTypeOptions 1
    const isK8s = cluster.type === 1;
    return isK8s ? '二' : '三'; // k8s 不选目标机器,因此是第二部，仅展示判断
  }, [cluster]);

  // k8s容器 clusterTypeOptions 1
  const isK8s = cluster.type === 1;

  useEffect(() => {
    if (template && template.scriptContent) {
      setCodeContent(template.scriptContent);
    } else {
      setCodeContent('');
    }
  }, [template, setCodeContent]);

  const handleClose = (row) => {
    setVisible(false);
    if (row) {
      setTemplate(row);
    }
  };

  return (
    <Root className='narrow-scrollbar fadeIn'>
      <OperateTitle
        label={`第${step}步：`}
        title='选择脚本来源'
        operator={
          <Space align='center'>
            <Checkbox
              checked={isTemp}
              onChange={() => {
                toggleTemp();
                setCodeContent('');
                setTemplate(null);
              }}
            >
              临时脚本
            </Checkbox>
            {!isTemp && (
              <Button variant='outline' theme='primary' onClick={() => setVisible(true)}>
                从脚本模板中选择
              </Button>
            )}
          </Space>
        }
      />
      <Content>
        <CodeMirrorLight
          readOnly={!isTemp}
          onChange={setCodeContent}
          value={codeContent || ''}
          style={{ maxHeight: 400 }}
        />
      </Content>
      <SelectScriptModal visible={visible} handleClose={handleClose} isK8s={isK8s} />
    </Root>
  );
}

export default connect(
  (state) => ({
    isTemp: state.execScript.isTemp,
    cluster: state.execScript.cluster,
    template: state.execScript.template,
    codeContent: state.execScript.codeContent,
  }),
  {
    toggleTemp,
    setTemplate,
    setCodeContent,
  },
)(SelectScript);

const Root = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding: 5px 10px;
  box-sizing: border-box;
  flex: 1;
  .code-mirror-light {
    flex: 1;
  }
`;
